module.exports = __webpack_public_path__ + "static/img/banner02.daa04ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitemanage/banner02.png
// module id = 1doV
// module chunks = 1